import { render, staticRenderFns } from "./ViewProgramDetails.vue?vue&type=template&id=a2ed01dc&scoped=true&lang=pug&"
import script from "./ViewProgramDetails.vue?vue&type=script&lang=js&"
export * from "./ViewProgramDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewProgramDetails.vue?vue&type=style&index=0&id=a2ed01dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ed01dc",
  null
  
)

export default component.exports